import { gql } from "@apollo/client";

export const CATEGORY_FRAGMENT = gql`
  fragment CategoryPart on Category {
    id
    name
    sitesCount
  }
`;

export const CREATE_CATEGORY = gql`
  mutation CreateCategoryMutation($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategoryMutation($id: Int!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const CATEGORIES = gql`
  query CategoriesQuery {
    categories {
      results {
        ...CategoryPart
      }
    }
  }
  ${CATEGORY_FRAGMENT}
`;

export const CATEGORY = gql`
  query CategoryQuery($id: Int!) {
    category(id: $id) {
      ok
      error
      result {
        id
        name
      }
    }
  }
`;
